import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RadioButtonItem } from './sg-radio-button.model';

@Component({
  selector: 'sg-radio-button',
  templateUrl: './sg-radio-button.component.html',
  styleUrls: ['./sg-radio-button.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SgRadioButtonComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class SgRadioButtonComponent implements ControlValueAccessor {
  //#region Properties
  @Input() items: RadioButtonItem[] = [];
  @Input() alignment?: 'vertical' | 'horizontal' = 'vertical';
  @Input() errorMessage?: string;
  @Input() disabled = false;
  @Input() selectedValue: any;
  @Output() valueChange = new EventEmitter<any>();
  //#endregion

  private onChange = (value: any) => {};
  private onTouched = () => {};

  //#region Public Methods
  onValueChange(value: any): void {
    this.onChange(value);
    this.onTouched();
    this.valueChange.emit(value);
  }
  //#endregion

  //#region ControlValueAccessor Methods
  writeValue(value: any): void {
    this.selectedValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  //#endregion
}
